/** True for the browser's "storage is full" error, bare or wrapped by Dexie. */
export function isQuotaError(err: unknown): boolean {
  const e = err as { name?: string; inner?: unknown } | null | undefined;
  return e?.name === 'QuotaExceededError' || (e?.inner !== undefined && isQuotaError(e.inner));
}
